import { Fragment } from 'react';

import { NestedPageHeader } from '#packages/web/layouts/page/header';
import { PageContent } from '#packages/web/layouts/page/page-content';

import { PageErrorBoundary } from '#apps/client-web/app/components/page-error-boundary';
import { useLogger } from '#apps/client-web/app/hooks/use-logger';
import { useNavigateBack } from '#apps/client-web/app/hooks/use-navigate-back';

import { useNotFoundPageViewModel } from './not-found.view-model';
import { NotFoundPageContainer } from './not-found.container';

export const NotFoundPage = () => {
  const logger = useLogger('pages/not-found');
  const onBack = useNavigateBack({ logger });
  const viewModel = useNotFoundPageViewModel({ logger });

  return (
    <Fragment>
      <NestedPageHeader title="Page Not Found" onNavigationIconClick={onBack} />
      <PageContent>
        <PageErrorBoundary onActionClick={onBack}>
          <NotFoundPageContainer viewModel={viewModel} />
        </PageErrorBoundary>
      </PageContent>
    </Fragment>
  );
};
